import React from 'react';
import { 
  Box, 
  AppBar, 
  Toolbar, 
  Typography,
  IconButton,
  useTheme
} from '@mui/material';
import {
  Menu as MenuIcon
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { SponsFINavigation } from './Navigation';

const drawerWidth = 240;

const Main = styled('main', { 
  shouldForwardProp: (prop) => prop !== 'open' 
})<{ open?: boolean }>(({ theme, open }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidth}px`,
  ...(open && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  }),
}));

interface DashboardLayoutProps {
  children: React.ReactNode;
}

export const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  const [open, setOpen] = React.useState(true);
  const theme = useTheme();

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar position="fixed" sx={{ zIndex: theme.zIndex.drawer + 1 }}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerToggle}
            edge="start"
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            SponsFI Dashboard
          </Typography>
        </Toolbar>
      </AppBar>
      
      <SponsFINavigation />
      
      <Main open={open}>
        <Toolbar /> {/* Spacing for AppBar */}
        {children}
      </Main>
    </Box>
  );
}; 